import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from './../store'

import SignIn from "@/views/teacher/SignIn.vue"
import SignInTwoFactor from "@/views/teacher/SignInTwoFactor.vue"
import SheetList from "@/views/teacher/SheetList.vue"
import SheetEdit from "@/views/teacher/SheetEdit.vue"
import FieldEdit from "@/views/teacher/FieldEdit.vue"
import DigitalPaperFieldEdit from "@/views/teacher/DigitalPaperFieldEdit.vue"
import CorrectImageUpload from "@/views/teacher/CorrectImageUpload.vue"
import AnswerImageUpload from "@/views/teacher/AnswerImageUpload.vue"
import QuestionImageUpload from "@/views/teacher/QuestionImageUpload.vue"
import PositionEdit from "@/views/teacher/PositionEdit.vue"
import ScorePositionEdit from "@/views/teacher/ScorePositionEdit.vue"
import RecogPositionEdit from "@/views/teacher/RecogPositionEdit.vue"
import MondaiPdfUpload from "@/views/teacher/MondaiPdfUpload.vue"
import KaitouPdfUpload from "@/views/teacher/KaitouPdfUpload.vue"
import SheetUpload from "@/views/teacher/SheetUpload.vue"
import WebupList from "@/views/teacher/WebupList.vue"
import WebupDetail from "@/views/teacher/WebupDetail.vue"
import SaitenList from "@/views/teacher/SaitenList.vue"
import SaitenInput from "@/views/teacher/SaitenInput.vue"
import SaitenInputScoreStamp from "@/views/teacher/SaitenInputScoreStamp.vue"
import SaitenInputIchimai from "@/views/teacher/SaitenInputIchimai.vue"
import SumupScoreAverageList from "@/views/teacher/SumupScoreAverageList.vue"
import SumupScoreDistributionList from "@/views/teacher/SumupScoreDistributionList.vue"
import SumupMajorNoScoreRateList from "@/views/teacher/SumupMajorNoScoreRateList.vue"
import SumupViewPointScoreRateList from "@/views/teacher/SumupViewPointScoreRateList.vue"
import SumupQuestionScoreRateList from "@/views/teacher/SumupQuestionScoreRateList.vue"
import ResultRankList from "@/views/teacher/ResultRankList.vue"
import ResultRankDetail from "@/views/teacher/ResultRankDetail.vue"
import BulkSenMail from "@/views/teacher/BulkSendMail.vue"

import CbtSheetList from "@/views/teacher/CbtSheetList.vue"
import CbtSheetEdit from "@/views/teacher/CbtSheetEdit.vue"
import CbtScheduleEdit from "@/views/teacher/CbtScheduleEdit.vue"

import EntranceSheetList from "@/views/teacher/EntranceSheetList.vue"
import EntranceSheetEdit from "@/views/teacher/EntranceSheetEdit.vue"

import EntranceCompareSheetList from "@/views/teacher/EntranceCompareSheetList.vue"

import StudentList from "@/views/teacher/StudentList.vue";
import StudentEdit from "@/views/teacher/StudentEdit.vue";
import StudentExcelUpload from "@/views/teacher/StudentExcelUpload.vue";
import StudentCleaning from "@/views/teacher/StudentCleaning.vue";
import UserEdit from "@/views/teacher/UserEdit.vue";

import TeacherList from "@/views/teacher/TeacherList.vue";
import TeacherCreate from "@/views/teacher/TeacherCreate.vue";
import TeacherExcelUpload from "@/views/teacher/TeacherExcelUpload.vue";
import TeacherAccessibleStudentPageList from "@/views/teacher/TeacherAccessibleStudentPageList.vue";
import TeacherAccessibleStudentPageUpload from "@/views/teacher/TeacherAccessibleStudentPageUpload.vue";

import EntranceTeacherList from "@/views/teacher/EntranceTeacherList.vue";
import EntranceTeacherCreate from "@/views/teacher/EntranceTeacherCreate.vue";
import EntranceTeacherExcelUpload from "@/views/teacher/EntranceTeacherExcelUpload.vue";

import SchoolList from "@/views/teacher/SchoolList.vue";
import SchoolEdit from "@/views/teacher/SchoolEdit.vue";

import SumupList from "@/views/teacher/SumupList.vue"
import SumupEdit from "@/views/teacher/SumupEdit.vue"
import SumupDetailTotal from "@/views/teacher/SumupDetailTotal.vue"
import SumupDetailCurriculum from "@/views/teacher/SumupDetailCurriculum.vue"
import SumupResultRankListTotal from "@/views/teacher/SumupResultRankListTotal.vue"
import SumupResultRankListCurriculum from "@/views/teacher/SumupResultRankListCurriculum.vue"
import ClassroomAuthorize from "@/views/teacher/ClassroomAuthorize.vue"
import ClassroomSheetEdit from "@/views/teacher/ClassroomSheetEdit.vue"
import TeamsAuthorize from "@/views/teacher/TeamsAuthorize.vue"
import TeamsSheetEdit from "@/views/teacher/TeamsSheetEdit.vue"

import SendAnswerImage from "@/views/teacher/SendAnswerImage.vue"

import SortAnswerImage from "@/views/teacher/SortAnswerImage.vue"

// 生徒サイト
import StudentSignIn from '@/views/student/SignIn.vue'
import StudentPasswordEdit from '@/views/student/PasswordEdit.vue'
import StudentMailEdit from '@/views/student/MailEdit.vue'
import StudentSheetList from '@/views/student/SheetList.vue'
import StudentMondaiPdfRender from '@/views/student/MondaiPdfRender.vue'
import StudentSheetUpload from '@/views/student/SheetUpload.vue'
import DigitalPaperList from "@/views/student/DigitalPaperList.vue"
import FileList from "@/views/student/FileList.vue"
import ResultImagePreview from "@/views/student/ResultImagePreview.vue"
import StudentHomeworkSheetList from '@/views/student/HomeworkSheetList.vue'

// Googleログイン
import DigitalPaperSignIn from '@/views/digital_paper/SignIn.vue'
import AuthorizedCallback from '@/views/digital_paper/AuthorizedCallback.vue'
import TeacherAuthorizedCallback from '@/views/teacher/AuthorizedCallback.vue'
import StudentAuthorizedCallback from '@/views/student/AuthorizedCallback.vue'

import DigitalPaperSheetList from '@/views/digital_paper/SheetList.vue'
import DigitalPaperSheetEdit from "@/views/teacher/DigitalPaperSheetEdit.vue"
import AnswerInput from "@/views/digital_paper/AnswerInput.vue"
import DigitalPaperResultRankDetail from "@/views/digital_paper/ResultRankDetail.vue"

// 模試
import PracticeSumupList from "@/views/teacher/PracticeSumupList.vue"
import PracticeSumupEdit from "@/views/teacher/PracticeSumupEdit.vue"
import PracticeSheetList from "@/views/teacher/PracticeSheetList.vue"
import PracticeCompareSheetList from "@/views/teacher/PracticeCompareSheetList.vue"
import PracticeSumupUnitCurriculumEdit from "@/views/teacher/PracticeSumupUnitCurriculumEdit.vue"
import PracticeSumupUnitCourseEdit from "@/views/teacher/PracticeSumupUnitCourseEdit.vue"
import PracticeSumupUnitMultiEdit from "@/views/teacher/PracticeSumupUnitMultiEdit.vue"
import PracticeSumupResultDispEdit from "@/views/teacher/PracticeSumupResultDispEdit.vue"
import PracticeFieldEdit from "@/views/teacher/PracticeFieldEdit.vue"
import PracticePart1Edit from "@/views/teacher/PracticePart1Edit.vue"
import PracticeSumupResultRankListTotal from "@/views/teacher/PracticeSumupResultRankListTotal.vue"
import PracticeSumupResultRankListCurriculum from "@/views/teacher/PracticeSumupResultRankListCurriculum.vue"
import PracticeSumupDetailTotal from "@/views/teacher/PracticeSumupDetailTotal.vue"
import PracticeSumupDetailCurriculum from "@/views/teacher/PracticeSumupDetailCurriculum.vue"
import PracticeFileUploadList from '@/views/teacher/PracticeFileUploadList.vue'
import PracticeFileUploadDetailPerson from '@/views/teacher/PracticeFileUploadDetailPerson.vue'
import PracticeFileUploadDetailCommon from '@/views/teacher/PracticeFileUploadDetailCommon.vue'

// 模試生徒サイト
import PracticeSignIn from '@/views/practice_examinee/SignIn.vue'
import PracticeExamineeResultTop from '@/views/practice_examinee/ResultTop.vue'
import PracticeExamineeResultDetail from '@/views/practice_examinee/ResultDetail.vue'
import PracticeExamineeErrorPage from '@/views/practice_examinee/ErrorPage.vue'

// 試験削除
import SheetDestroy from '@/views/teacher/SheetDestroy.vue'

// 個別PDFアップロード
import StudentFileUploadList from '@/views/teacher/StudentFileUploadList.vue'
import StudentFileUploadDetail from '@/views/teacher/StudentFileUploadDetail.vue'

// 課題管理一覧
import HomeworkSheetList from '@/views/teacher/HomeworkSheetList.vue'
import HomeworkSheetEdit from '@/views/teacher/HomeworkSheetEdit.vue'
import HomeworkAnswerImageUpload from '@/views/teacher/HomeworkAnswerImageUpload.vue'
import HomeworkPositionEdit from '@/views/teacher/HomeworkPositionEdit.vue'

// 学校別科目管理
import SchoolSubjectList from '@/views/teacher/SchoolSubjectList.vue'
import SchoolSubjectUpload from '@/views/teacher/SchoolSubjectUpload.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  { path: "/", name: "SignIn", component: SignIn },
  { path: "/teacher_site/sign_in_two_factor", name: "SignInTwoFactor", component: SignInTwoFactor },
  { path: "/teacher_site/sheet_list", name: "SheetList", component: SheetList },
  { path: "/teacher_site/sheet_edit/new", name: "SheetEditNew", component: SheetEdit },
  { path: "/teacher_site/sheet_edit/:sheet_group_key", name: "SheetEdit", component: SheetEdit },
  { path: "/teacher_site/field_edit/:sheet_group_key", name: "FieldEdit", component: FieldEdit },
  { path: "/teacher_site/digital_paper_field_edit/:sheet_group_key", name: "DigitalPaperFieldEdit", component: DigitalPaperFieldEdit },
  { path: "/teacher_site/correct_image_upload/:sheet_group_key", name: "CorrectImageUpload", component: CorrectImageUpload },
  { path: "/teacher_site/answer_image_upload/:sheet_group_key", name: "AnswerImageUpload", component: AnswerImageUpload },
  { path: "/teacher_site/question_image_upload/:sheet_group_key", name: "QuestionImageUpload", component: QuestionImageUpload },
  { path: "/teacher_site/position_edit/:sheet_group_key", name: "PositionEdit", component: PositionEdit },
  { path: "/teacher_site/score_position_edit/:sheet_group_key", name: "ScorePositionEdit", component: ScorePositionEdit },
  { path: "/teacher_site/recog_position_edit/:sheet_group_key", name: "RecogPositionEdit", component: RecogPositionEdit },
  { path: "/teacher_site/mondai_pdf_upload/:sheet_group_key", name: "MondaiPdfUpload", component: MondaiPdfUpload },
  { path: "/teacher_site/kaitou_pdf_upload/:sheet_group_key", name: "KaitouPdfUpload", component: KaitouPdfUpload },
  { path: "/teacher_site/sheet_upload/:sheet_id", name: "SheetUpload", component: SheetUpload },
  { path: "/teacher_site/webup_list/:sheet_group_key", name: "WebupList", component: WebupList },
  { path: "/teacher_site/webup_detail/:webup_history_id", name: "WebupDetail", component: WebupDetail },
  { path: "/teacher_site/saiten_list/:sheet_id", name: "SaitenList", component: SaitenList },
  { path: "/teacher_site/saiten_input/:sheet_id/:sheet_field_id", name: "SaitenInput", component: SaitenInput },
  { path: "/teacher_site/saiten_input_score_stamp/:sheet_id/:sheet_field_id", name: "SaitenInputScoreStamp", component: SaitenInputScoreStamp },
  { path: "/teacher_site/saiten_input_ichimai/:sheet_id/:examinee_id", name: "SaitenInputIchimai", component: SaitenInputIchimai },
  { path: "/teacher_site/sumup_score_average_list/:sheet_group_key", name: "SumupScoreAverageList", component: SumupScoreAverageList },
  { path: "/teacher_site/sumup_score_distribution_list/:sheet_group_key", name: "SumupScoreDistributionList", component: SumupScoreDistributionList },
  { path: "/teacher_site/sumup_view_point_score_rate_list/:sheet_group_key", name: "SumupViewPointScoreRateList", component: SumupViewPointScoreRateList },
  { path: "/teacher_site/sumup_major_no_score_rate_list/:sheet_group_key", name: "SumupMajorNoCorrectRateList", component: SumupMajorNoScoreRateList },
  { path: "/teacher_site/sumup_question_score_rate_list/:sheet_group_key", name: "SumupQuestionCorrectRateList", component: SumupQuestionScoreRateList },
  { path: "/teacher_site/result_rank_list/:sheet_group_key", name: "ResultRankList", component: ResultRankList },
  { path: "/teacher_site/result_rank_detail/:sheet_id/:student_no", name: "ResultRankDetail", component: ResultRankDetail },
  { path: "/teacher_site/bulk_send_mail", name: "BulkSenMail", component: BulkSenMail},
  { path: "/teacher_site/sumup_list", name: "SumupList", component: SumupList},
  { path: "/teacher_site/sumup_edit/new", name: "SumupEditNew", component: SumupEdit },
  { path: "/teacher_site/sumup_edit/:sumup_group_id", name: "SumupEdit", component: SumupEdit },
  { path: "/teacher_site/sumup_result_rank_list_total/:sumup_group_id", name: "SumupResultRankListTotal", component: SumupResultRankListTotal },
  { path: "/teacher_site/sumup_result_rank_list_curriculum/:sumup_group_id/:curriculum_id", name: "SumupResultRankListCurriculum", component: SumupResultRankListCurriculum },
  { path: "/teacher_site/sumup_detail_total/:sumup_group_id", name: "SumupDetailTotal", component: SumupDetailTotal },
  { path: "/teacher_site/sumup_detail_curriculum/:sumup_group_id/:curriculum_id", name: "SumupDetailCurriculum", component: SumupDetailCurriculum },

  { path: "/teacher_site/student_list", name: "StudentList", component: StudentList },
  { path: "/teacher_site/student_edit/new", name: "StudentEditNew", component: StudentEdit },
  { path: "/teacher_site/student_edit/:id", name: "StudentEdit", component: StudentEdit },
  { path: "/teacher_site/student_excel_upload", name: "StudentExcelUpload", component: StudentExcelUpload },
  { path: "/teacher_site/student_cleaning", name: "StudentCleaning", component: StudentCleaning },
  { path: "/teacher_site/user_edit", name: "UserEdit", component: UserEdit },

  { path: "/teacher_site/teacher_list", name: "TeacherList", component: TeacherList},
  {
    path: "/teacher_site/teacher_create",
    name: "TeacherCreate",
    component: TeacherCreate,
    beforeEnter: (to, from, next) => {
      const queryRole = to.query?.["role"];
      const currentUser = store.state.currentUser;

      if (!currentUser?.role || (queryRole == "admin" && currentUser.role != "admin")) {
        store.state.currentUser = null;
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        next({path: "/"});
      } else {
        next();
      }
    }
  },
  {
    path: "/teacher_site/entrance_teacher_create",
    name: "EntranceTeacherCreate",
    component: EntranceTeacherCreate,
    beforeEnter: (to, from, next) => {
      const queryRole = to.query?.["role"];
      const currentUser = store.state.currentUser;

      if (!currentUser?.role || (queryRole == "admin" && currentUser.role != "admin")) {
        store.state.currentUser = null;
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        next({path: "/"});
      } else {
        next();
      }
    }
  },
  { path: "/teacher_site/teacher_excel_upload", name: "TeacherExcelUpload", component: TeacherExcelUpload},
  { path: "/teacher_site/teacher_accessible_student_page_list", name: "TeacherAccessibleStudentPageList", component: TeacherAccessibleStudentPageList},
  { path: "/teacher_site/teacher_accessible_student_page_upload", name: "TeacherAccessibleStudentPageUpload", component: TeacherAccessibleStudentPageUpload},
  { path: "/teacher_site/entrance_teacher_excel_upload", name: "EntranceTeacherExcelUpload", component: EntranceTeacherExcelUpload},
  { path: "/teacher_site/entrance_teacher_list", name: "EntranceTeacherList", component: EntranceTeacherList},
  {
    path: "/teacher_site/school_list",
    name: "SchoolList",
    component: SchoolList,
    beforeEnter: (to, from, next) => {
      const currentUser = store.state.currentUser;

      if (!currentUser?.role || currentUser.role != "admin") {
        store.state.currentUser = null;
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        next({path: "/"});
      } else {
        next();
      }
    }
  },
  {
    path: "/teacher_site/school_edit",
    name: "SchoolEdit",
    component: SchoolEdit,
    beforeEnter: (to, from, next) => {
      const currentUser = store.state.currentUser;

      if (!currentUser?.role || currentUser.role != "admin") {
        store.state.currentUser = null;
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        next({path: "/"});
      } else {
        next();
      }
    }
  },

  { path: "/teacher_site/cbt_sheet_list", name: "CbtSheetList", component: CbtSheetList },
  { path: "/teacher_site/cbt_sheet_edit/new", name: "CbtSheetEditNew", component: CbtSheetEdit },
  { path: "/teacher_site/cbt_sheet_edit/:sheet_group_key", name: "CbtSheetEdit", component: CbtSheetEdit },
  { path: "/teacher_site/cbt_schedule_edit/:sheet_group_key", name: "CbtScheduleEdit", component: CbtScheduleEdit },

  { path: "/teacher_site/entrance_sheet_list", name: "EntranceSheetList", component: EntranceSheetList },
  { path: "/teacher_site/entrance_sheet_edit/new", name: "EntranceSheetEditNew", component: EntranceSheetEdit },
  { path: "/teacher_site/entrance_sheet_edit/:sheet_group_key", name: "EntranceSheetEdit", component: EntranceSheetEdit },

  { path: "/teacher_site/entrance_compare_sheet_list", name: "EntranceCompareSheetList", component: EntranceCompareSheetList },

  { path: "/teacher_site/classroom_authorize", name: "GoogleClassroom", component: ClassroomAuthorize },
  { path: "/teacher_site/classroom_sheet_edit/new", name: "ClassroomSheetEditNew", component: ClassroomSheetEdit },
  { path: "/teacher_site/classroom_sheet_edit/:sheet_group_key", name: "ClassroomSheetEdit", component: ClassroomSheetEdit },
  { path: "/teacher_site/teams_authorize", name: "MicrosoftTeamsAuthorize", component: TeamsAuthorize },
  { path: "/teacher_site/teams_sheet_edit/new", name: "TeamsSheetEditNew", component: TeamsSheetEdit },
  { path: "/teacher_site/teams_sheet_edit/:sheet_group_key", name: "TeamsSheetEdit", component: TeamsSheetEdit },
  
  { path: "/teacher_site/send_answer_image/mail/:sheet_id", name: "SendAnswerImageMail", component: SendAnswerImage },
  { path: "/teacher_site/send_answer_image/classroom/:sheet_id", name: "SendAnswerImageClassroom", component: SendAnswerImage },

  { path: "/teacher_site/sort_answer_image/:sheet_id", name: "SortAnswerImage", component: SortAnswerImage },

  { path: "/teacher_site/sheet_destroy", name: "SheetDestroy", component: SheetDestroy },

  // 生徒サイト
  { path: "/:school_id/student_site/sign_in", name: "StudentSignIn", component: StudentSignIn },
  { path: "/:school_id/student_site/password_edit", name: "StudentPasswordEdit", component: StudentPasswordEdit },
  { path: "/:school_id/student_site/password_edit/inital_setting", name: "StudentPasswordEditInit", component: StudentPasswordEdit },
  { path: "/:school_id/student_site/mail_edit", name: "StudentMailEdit", component: StudentMailEdit },
  { path: "/:school_id/student_site/sheet_list", name: "StudentSheetList", component: StudentSheetList },
  { path: "/:school_id/student_site/homework_sheet_list", name: "StudentHomeworkSheetList", component: StudentHomeworkSheetList },
  { path: "/:school_id/student_site/mondai_pdf_render/:sheet_id", name: "StudentMondaiPdfRender", component: StudentMondaiPdfRender },
  { path: "/:school_id/student_site/sheet_upload/:sheet_id", name: "StudentSheetUpload", component: StudentSheetUpload },
  { path: "/:school_id/student_site/result_rank_detail/:sheet_id/:student_no", name: "StudentResultRankDetail", component: ResultRankDetail },
  { path: "/:school_id/student_site/digital_paper_list", name: "DigitalPaperList", component: DigitalPaperList },
  { path: "/:school_id/student_site/answer_input/:sheet_id", name: "AnswerInput", component: AnswerInput },
  { path: "/:school_id/student_site/file_list", name: "FileList", component: FileList },
  { path: "/:school_id/student_site/result_image_preview/:sheet_id", name: "ResultImagePreview", component: ResultImagePreview },

  // 教師アカウントで入る生徒サイトTOP
  { path: "/teacher_site/student_sheet_list", name: "StudentSheetListFromTeacher", component: StudentSheetList },
  { path: "/teacher_site/student_homework_sheet_list", name: "StudentHomeworkSheetListFromTeacher", component: StudentHomeworkSheetList },
  { path: "/teacher_site/mondai_pdf_render/:sheet_id", name: "StudentMondaiPdfRenderFromTeacher", component: StudentMondaiPdfRender },
  { path: "/teacher_site/student_sheet_upload/:sheet_id", name: "StudentSheetUploadFromTeacher", component: StudentSheetUpload },
  { path: "/teacher_site/result_rank_detail/:sheet_id/:student_no", name: "StudentResultRankDetailFromTeacher", component: ResultRankDetail },
  { path: "/teacher_site/digital_paper_list", name: "DigitalPaperListFromTeacher", component: DigitalPaperList },
  { path: "/teacher_site/answer_input/:sheet_id", name: "AnswerInputFromTeacher", component: AnswerInput },
  { path: "/teacher_site/file_list", name: "FileListFromTeacher", component: FileList },
  { path: "/teacher_site/result_image_preview/:sheet_id", name: "ResultImagePreviewFromTeacher", component: ResultImagePreview },

  // Google認証
  { path: "/digital_paper_site/sign_in", name: "DigitalPaperSignIn", component: DigitalPaperSignIn },
  { path: "/digital_paper_site/sign_in_callback", name: "AuthorizedCallback", component: AuthorizedCallback },
  { path: "/digital_paper_site/sheet_list", name: "DigitalPaperSheetList", component: DigitalPaperSheetList },
  { path: "/digital_paper_site/answer_input/:sheet_id", name: "AnswerInputFromDpSite", component: AnswerInput },
  { path: "/digital_paper_site/result_rank_detail/:sheet_id", name: "DigitalPaperResultRankDetail", component: DigitalPaperResultRankDetail },
  { path: "/digital_paper_site/result_image_preview/:sheet_id", name: "ResultImagePreviewFromDigitalPaper", component: ResultImagePreview },
  { path: "/teacher_site/digital_paper_sheet_edit/new", name: "DigitalPaperSheetEditNew", component: DigitalPaperSheetEdit },
  { path: "/teacher_site/digital_paper_sheet_edit/:sheet_group_key", name: "DigitalPaperSheetEdit", component: DigitalPaperSheetEdit },
  { path: "/teacher_site/authorized_callback", name: "TeacherAuthorizedCallback", component: TeacherAuthorizedCallback },
  { path: "/:school_id/student_site/authorized_callback", name: "StudentAuthorizedCallback", component: StudentAuthorizedCallback },

  // 模試
  { path: "/teacher_site/practice_sumup_list", name: "PracticeSumupList", component: PracticeSumupList},
  { path: "/teacher_site/practice_sumup_edit/new", name: "PracticeSumupEditNew", component: PracticeSumupEdit },
  { path: "/teacher_site/practice_sumup_edit/:sumup_group_id", name: "PracticeSumupEdit", component: PracticeSumupEdit },
  { path: "/teacher_site/practice_sheet_list", name: "PracticeSheetList", component: PracticeSheetList },
  { path: "/teacher_site/practice_compare_sheet_list", name: "PracticeCompareSheetList", component: PracticeCompareSheetList },
  { path: "/teacher_site/practice_sumup_unit_curriculum_edit/:sumup_group_id", name: "PracticeSumupUnitCurriculumEdit", component: PracticeSumupUnitCurriculumEdit },
  { path: "/teacher_site/practice_sumup_unit_course_edit/:sumup_group_id", name: "PracticeSumupUnitCourseEdit", component: PracticeSumupUnitCourseEdit },
  { path: "/teacher_site/practice_sumup_unit_multi_edit/:sumup_group_id", name: "PracticeSumupUnitMultiEdit", component: PracticeSumupUnitMultiEdit },
  { path: "/teacher_site/practice_sumup_result_disp_edit/:sumup_group_id", name: "PracticeSumupResultDispEdit", component: PracticeSumupResultDispEdit },
  { path: "/teacher_site/practice_field_edit/:sheet_group_key", name: "PracticeFieldEdit", component: PracticeFieldEdit },
  { path: "/teacher_site/practice_part1_edit/:sheet_group_key", name: "PracticePart1Edit", component: PracticePart1Edit },
  { path: "/teacher_site/practice_sumup_result_rank_list_total/:sumup_group_id", name: "PracticeSumupResultRankListTotal", component: PracticeSumupResultRankListTotal },
  { path: "/teacher_site/practice_sumup_result_rank_list_curriculum/:sumup_group_id/:sumup_unit_id", name: "PracticeSumupResultRankListCurriculum", component: PracticeSumupResultRankListCurriculum },
  { path: "/teacher_site/practice_sumup_detail_total/:sumup_group_id", name: "PracticeSumupDetailTotal", component: PracticeSumupDetailTotal },
  { path: "/teacher_site/practice_sumup_detail_curriculum/:sumup_group_id/:sumup_unit_id", name: "PracticeSumupDetailCurriculum", component: PracticeSumupDetailCurriculum },
  { path: "/teacher_site/practice_examinee_result_top", name: "PracticeExamineeResultTopFromTeacher", component: PracticeExamineeResultTop },
  { path: "/teacher_site/practice_examinee_result_detail/:sumup_unit_id", name: "PracticeExamineeResultDetailFromTeacher", component: PracticeExamineeResultDetail },
  { path: "/teacher_site/practice_file_upload_list/:sumup_group_id", name: "PracticeFileUploadList", component: PracticeFileUploadList },
  { path: "/teacher_site/practice_file_upload_detail_person/:practice_file_upload_id", name: "PracticeFileUploadDetailPerson", component: PracticeFileUploadDetailPerson },
  { path: "/teacher_site/practice_file_upload_detail_common/:practice_file_upload_id", name: "PracticeFileUploadDetailCommon", component: PracticeFileUploadDetailCommon },

  { path: "/teacher_site/student_file_upload_list", name: "StudentFileUploadList", component: StudentFileUploadList },
  { path: "/teacher_site/student_file_upload_detail/:student_file_upload_id", name: "StudentFileUploadDetail", component: StudentFileUploadDetail },

  // 課題管理
  { path: "/teacher_site/homework_sheet_list", name: "HomeworkSheetList", component: HomeworkSheetList },
  { path: "/teacher_site/homework_sheet_edit/new", name: "HomeworkSheetEditNew", component: HomeworkSheetEdit },
  { path: "/teacher_site/homework_sheet_edit/:sheet_group_key", name: "HomeworkSheetEdit", component: HomeworkSheetEdit },
  { path: "/teacher_site/homework_answer_image_upload/:sheet_group_key", name: "HomeworkAnswerImageUpload", component: HomeworkAnswerImageUpload },
  { path: "/teacher_site/homework_position_edit/:sheet_group_key", name: "HomeworkPositionEdit", component: HomeworkPositionEdit },

  // 模試生徒サイト
  { path: "/:school_id/candidate/:nendo/:exec_times/sign_in", name: "PracticeSignIn", component: PracticeSignIn },
  { path: "/candidate/result_top", name: "PracticeExamineeResultTop", component: PracticeExamineeResultTop },
  { path: "/candidate/result_detail/:sumup_unit_id", name: "PracticeExamineeResultDetail", component: PracticeExamineeResultDetail },
  { path: "/candidate/error", name: "PracticeExamineeErrorPage", component: PracticeExamineeErrorPage },

  // 学校別科目管理
  { path: "/teacher_site/school_subject_list", name: "SchoolSubjectList", component: SchoolSubjectList },
  { path: "/teacher_site/school_subject_upload", name: "SchoolSubjectUpload", component: SchoolSubjectUpload },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
